// extracted by mini-css-extract-plugin
export default {"link":"privacy_link__oFm22","modalOverlay":"privacy_modalOverlay__dq-AN","modalContent":"privacy_modalContent__+qw32","closeButton":"privacy_closeButton__0WYRt"};